import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { switchMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux-actions';

import { GET_PERSONAL_PAYROLL_DETAIL_CALL, GET_PERSONAL_PAYROLL_LIST_CALL } from '@src/store/types/payroll';
import { getPersonalPayrollDetail, getPersonalPayrollList } from '@src/services/payroll';
import {
	getPersonalPayrollListDone,
	getPersonalPayrollListFail,
	getPersonalPayrollDetailDone,
	getPersonalPayrollDetailFail,
} from '../actions/payroll';

export const getPersonalPayrollListEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PERSONAL_PAYROLL_LIST_CALL),
	switchMap(
		() => fromPromise(getPersonalPayrollList()).pipe(
			switchMap(res => of(getPersonalPayrollListDone({ res }))),
			catchError(error => of(getPersonalPayrollListFail({ error }))),
		),
	),
);

export const getPersonalPayrollDetailEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_PERSONAL_PAYROLL_DETAIL_CALL),
	switchMap(
		({ payload }) => fromPromise(getPersonalPayrollDetail(payload)).pipe(
			switchMap(res => of(getPersonalPayrollDetailDone({ res }))),
			catchError(error => {
				if (payload.onError) payload.onError(error.response);
				return of(getPersonalPayrollDetailFail({ error }));
			}),
		),
	),
);
